import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {AuthService} from '@app/core/services/auth.service';
import {Shift} from '@app/core/models/shift.model';
import {Observable} from 'rxjs';
import {Pagination} from '@app/core/models/pagination.model';
import {map} from 'rxjs/operators';
import {ShiftService} from '@app/modules/shared/services/shift.service';
import {UserService} from '@app/modules/shared/services/user.service';

export interface IGetStackedActionsResponse {
	shiftExchanges: Shift[];
	shiftRequests: Shift[];
}

@Injectable({
	providedIn: 'root',
})
export class ActionService {
	constructor(
		public authService: AuthService,
		private shiftService: ShiftService,
		private httpService: HttpService,
		private userService: UserService,
	) {
	}

	public getStackedActions(): Promise<IGetStackedActionsResponse> {
		return new Promise<IGetStackedActionsResponse>((resolve, reject) => {
			this.httpService.getJson('actions/shiftsWithBids').subscribe((res: any) => {
				const shiftExchanges = [];
				const shiftRequests = [];
				res.data.forEach((shift) => {
					const formattedShift = this.shiftService.fresh(shift);
					if (formattedShift['users_who_bid'].length === 1) {
						formattedShift['selected_user_id'] = formattedShift['users_who_bid'][0]['id'];
					}
					formattedShift['users_who_bid'] = formattedShift['users_who_bid'].map(u => this.userService.fresh(u));
					if (shift.user.id !== 1) {
						shiftExchanges.push(formattedShift);
					}
					if (shift.user.id === 1) {
						shiftRequests.push(formattedShift);
					}
				});
				resolve({shiftExchanges, shiftRequests});
			});
		});
	}

	public getShiftRequests(page: number, page_size: number): Observable<any> {
		return this.httpService.getJson('actions/shiftsWithBids', {
			page,
			page_size,
			'filter[available_user]': 1,
		}).pipe(map((res: any) => {
			res.data = res.data.map(s => this.shiftService.fresh(s));
			res.pagination = new Pagination().deserialize(res.pagination).getQOPagination();

			return res;
		}));
	}

	public getShiftSwapRequests(page: number, page_size: number): Observable<any> {
		return this.httpService.getJson('actions/shiftsWithBids', {
			page,
			page_size,
			'filter[available_user]': 0,
		}).pipe(map((res: any) => {
			res.data = res.data.map(s => this.shiftService.fresh(s));
			res.pagination = new Pagination().deserialize(res.pagination).getQOPagination();

			return res;
		}));
	}

	public approveShiftRequest(shiftId: number, userId: number): Observable<any> {
		return this.httpService.patchJson('shifts/' + shiftId, {user_id: userId});
	}

	public removeShiftRequest(shiftId: number): Observable<any> {
		return this.httpService.deleteJson('actions/shiftsWithBids', {shift_id: shiftId});
	}
}
